/*@flow*/
import gql from 'graphql-tag';
import type { DocumentNode } from 'graphql';

export default (gql(`
  query GetItemViewResource($id: ID!, $resourceName: String!, $companyId: ID!) {
    company(id: $companyId) {
      id
      resource(id: $id, resourceName: $resourceName) {
        ... on Organization {
          id
          name
          logo
          phone
          website
          memberType
          category
          primaryContactName
          primaryContactEmail
          address
          naicsIndustry
          planType
          memberStatus
          seats
          inviteStatusList
          description
          updatedAt
        }
        ... on Unit {
          __typename
          id
          hashid
          address
          name
          visibility
          category
          subcategories
          status
          use
          floor
          suite
          rentableSqft
          tags
          annualDistrictPayment
          districtPropertyClass
          teaserPhoto
          latlon
          companyName
          companyUrl
          mapLabel
          updatedAt
          contactName
          contactEmail
          contactPhone
        }
        ... on Tenant {
          __typename
          id
          hashid
          name
          visibility
          address
          category
          subcategories
          tags
          status
          description
          use
          rentableSqft
          businessOpenedOn
          businessClosedOn
          leaseStart
          leaseExpiration
          askingPricePerSqft
          contractValuePerSqft
          url
          hours
          phone
          fax
          email
          perks
          facebookLink
          instagramLink
          twitterLink
          youtubeLink
          pinterestLink
          yelpLink
          primaryContactName
          primaryContactPhone
          primaryContactEmail
          secondaryContactName
          secondaryContactPhone
          secondaryContactEmail
          teaserPhoto
          latlon
          companyName
          companyUrl
          mapLabel
          updatedAt
        }
        ... on StreetscapeIssue {
          __typename
          id
          hashid
          name
          status
          address
          category
          subcategories
          tags
          notes
          details
          maintenanceDetails
          teaserPhoto
          latlon
          dateOfIncident
          timeOfIncident
          companyName
          cost
          companyUrl
          createdAt
          mapLabel
          updatedAt
        }
        ... on StreetscapeAsset {
          __typename
          id
          hashid
          name
          address
          radiusMeters
          status
          visibility
          category
          subcategories
          tags
          notes
          teaserPhoto
          latlon
          companyName
          companyUrl
          description
          mapLabel
          cost
          updatedAt
        }
        ... on Property {
          __typename
          id
          hashid
          apn
          municipalId
          name
          address
          visibility
          category
          tags
          annualPropertyTax
          annualDistrictAssessment
          section
          propertyBlockId
          propertyLotId
          condo
          owner
          propertyOwners
          propertyClass
          taxClass
          districtClass
          annualDistrictAssessmentExemptions
          totalAssessedValue
          lotPerimeter
          lotDepth
          lotFront
          lotSide1
          lotSide2
          lotSide3
          lotRear
          lotAreaTotal
          residentialArea
          commercialArea
          retailArea
          officeArea
          industrialArea
          agriculturalArea
          communityArea
          otherArea
          totalBldgArea
          billingContactName
          billingContactEmail
          billingContactPhone
          billingAddressStreet
          billingAddressCity
          billingAddressState
          billingAddressZip
          billingAddressCountry
          teaserPhoto
          latlon
          companyName
          companyUrl
          mapLabel
          description
          notes
          updatedAt
        }
        ... on Listing {
          __typename
          id
          hashid
          name
          address
          status
          visibility
          listingType
          availability
          ceilingHeightFeet
          frontageFeet
          contactName
          contactCompany
          contactEmail
          phone
          secondaryContactName
          secondaryContactEmail
          secondaryContactPhone
          secondaryContactCompany
          description
          rentableSqft
          intendedUse
          currentUses
          tags
          notes
          url
          email
          incentives
          pricePerSqft
          askingRentPerMonth
          askingPrice
          marketValue
          auxSpaceSqft
          teaserPhoto
          latlon
          companyName
          companyUrl
          mapLabel
          updatedAt
          closeDate
        }
        ... on Event {
          __typename
          id
          hashid
          name
          address
          visibility
          status
          startsAt
          endsAt
          isRecurring
          category
          tags
          locationName
          description
          url
          registrationUrl
          teaserPhoto
          latlon
          companyName
          companyUrl
          mapLabel
          updatedAt
        }
        ... on Development {
          __typename
          id
          hashid
          name
          address
          status
          visibility
          developmentType
          description
          floorArea
          financing
          expectedCompletionYear
          uses
          tags
          notes
          url
          cost
          program
          multifamilyUnits
          affordableMultifamilyUnits
          multifamilySqft
          officeSqft
          retailSqft
          commercialSqft
          industrialSqft
          otherSqft
          hospitalityUnits
          hospitalitySqft
          commFacilitiesSqft
          parkingSpots
          architect
          developer
          ownershipType
          floors
          teaserPhoto
          latlon
          companyName
          companyUrl
          mapLabel
          updatedAt
        }
        ... on Contact {
          __typename
          id
          hashid
          name
          contactType
          visibility
          tags
          organizationName
          mailingAddress
          email
          phone
          cellPhone
          homePhone
          fax
          city
          zip
          stateOrProvince
          title
          notes
          propertyAddress
          propertyLotId
          propertyCity
          propertyCountryAbbr
          latlon
          companyName
          companyUrl
          mapLabel
          updatedAt
        }
        ... on Building {
          __typename
          id
          hashid
          name
          address
          description
          status
          visibility
          category
          tags
          propertyMunicipalId
          bin
          propertyManagement
          contact
          contactEmail
          contactPhone
          uses
          amenities
          numStories
          numUnits
          housingUnitsTotal
          numAffordableUnits
          numMarketRateUnits
          totalFloorAreaSqft
          residentialSqFt
          retailSqFt
          officeSqFt
          commercialSqFt
          hotelSqFt
          industrialSqFt
          otherSqFt
          amenitiesSqFt
          rentableAreaSqft
          typicalFloorSizeSqft
          totalUnits
          yearBuilt
          yearLastRenovated
          phone
          url
          notes
          teaserPhoto
          latlon
          companyName
          companyUrl
          mapLabel
          updatedAt
        }
      }
    }
  }
`): DocumentNode);
